import React from 'react'
import { ReactComponent as NotFoundIcon } from '../../../assets/icons/search-no-info-secondary.svg'

export const SISTEM_ACTIONS = [
  {
    icon: {}, // importar o svg como reactComponent
    title: 'Cadastrar',
    subtitle: 'Cadastre um novo tutor ou pet',
    action: {}, // Ação do botão começar
    isEnabled: true // mudar para os cards 'em breve'
  }
  // Continua aqui
]

export const INITIAL_CURRENT_PAGE = 1
export const LIMIT = 8
export const LIST_TYPES = {
  initial: 'tutors',
  tutor: 'tutors',
  pet: 'pets'
}
export const INITIAL_TEXT = ''

export const INITIAL_DEFAULT_VALUE = undefined

export const NOT_FOUND_ICON = <NotFoundIcon />

export const NOT_FOUND_TEXT = {
  title: 'Desculpe, não encontramos um resultado para sua busca',
  pets: 'Experimente alterar os filtros de busca ou procurar por um nome de pet ou raça diferente. Caso o pet não esteja cadastrado você pode adicioná-lo clicando em “Novo Cadastro”',
  tutors: 'Experimente realizar uma nova busca por outro nome do tutor, CPF ou email. Caso este tutor não esteja cadastrado você pode adicioná-lo clicando em “Novo Cadastro”'
}

export const SHORTCUT_PARAM = 'nova_consulta'
